import cn from 'classnames';
import styles from './ThumbDislikeButton.module.scss';

type ThumbDislikeButtonProps = {
  className?: string;
  count: number;
  onClick: () => void;
  isFilled?: boolean;
};

export function ThumbDislikeButton({
  className,
  count,
  onClick,
  isFilled = false,
}: ThumbDislikeButtonProps) {
  const wrapperClassName = cn(styles.wrapper, className);

  return (
    <div className={wrapperClassName} onClick={onClick}>
      <img
        src={isFilled ? '/svg/thumb-down-filled.svg' : '/svg/thumb-down.svg'}
        alt="thumb-down"
        className={styles.icon}
      />
      {count > 0 && <span className={styles.count}>{count}</span>}
    </div>
  );
}
